/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEquipmentSettingCommand } from '../../models/create-equipment-setting-command';
import { CreateEquipmentSettingCommandResult } from '../../models/create-equipment-setting-command-result';

export interface ApiEquipmentSettingCreateEquipmentSettingPost$Params {
  
    /**
     * The command containing the details for the new equipment setting.
     */
    body?: CreateEquipmentSettingCommand
}

export function apiEquipmentSettingCreateEquipmentSettingPost(http: HttpClient, rootUrl: string, params?: ApiEquipmentSettingCreateEquipmentSettingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateEquipmentSettingCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiEquipmentSettingCreateEquipmentSettingPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateEquipmentSettingCommandResult>;
    })
  );
}

apiEquipmentSettingCreateEquipmentSettingPost.PATH = '/api/EquipmentSetting/CreateEquipmentSetting';
